<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        :data="results"
        height="100%"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>

        <el-table-column prop="groupId" label="分组">
          <template slot-scope="scope">{{
            scope.row.groupId === 1
              ? "Daily tasks"
              : scope.row.groupId === 2
              ? "One-time tasks"
              : "Common Task"
          }}</template>
        </el-table-column>

        <el-table-column prop="name" label="名称"></el-table-column>

        <el-table-column prop="title" label="标题"></el-table-column>

        <el-table-column prop="description" label="描述"></el-table-column>

        <el-table-column prop="btnName" label="按钮名称"></el-table-column>

        <el-table-column prop="score" label="积分"></el-table-column>

        <el-table-column prop="maxCount" label="每周期最多完成次数"></el-table-column>

        <el-table-column prop="eventCount" label="事件次数"></el-table-column>

        <el-table-column prop="sortNo" label="排序"></el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">{{ scope.row.status === 0 ? "启用" : "禁用" }} </template>
        </el-table-column>

        <!-- <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }} </template>
      </el-table-column> -->

        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">{{ scope.row.updateTime | formatDate }} </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="180px">
        <el-form-item label="分组">
          <el-select v-model="addForm.groupId" placeholder="任务分组">
            <el-option
              v-for="group in groups"
              :key="group.id"
              :value="group.id"
              :label="group.name"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="名称">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>

        <el-form-item label="描述">
          <el-input v-model="addForm.description"></el-input>
        </el-form-item>

        <el-form-item label="按钮名称">
          <el-input v-model="addForm.btnName"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="addForm.score"></el-input>
        </el-form-item>

        <el-form-item label="每日最多完成次数">
          <el-input v-model="addForm.maxCount"></el-input>
        </el-form-item>

        <el-form-item label="事件次数">
          <el-input v-model="addForm.eventCount" placeholder="几次事件表示完成一次任务"></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input v-model="addForm.sortNo"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="addForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交 </el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="180px">
        <el-input v-model="editForm.id" type="hidden"></el-input>

        <el-form-item label="分组">
          <el-select v-model="editForm.groupId" placeholder="任务分组">
            <el-option
              v-for="group in groups"
              :key="group.id"
              :value="group.id"
              :label="group.name"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>

        <el-form-item label="描述">
          <el-input v-model="editForm.description"></el-input>
        </el-form-item>

        <el-form-item label="按钮名称">
          <el-input v-model="editForm.btnName"></el-input>
        </el-form-item>

        <el-form-item label="积分">
          <el-input v-model="editForm.score"></el-input>
        </el-form-item>

        <el-form-item label="每日最多完成次数">
          <el-input v-model="editForm.maxCount"></el-input>
        </el-form-item>

        <el-form-item label="事件次数">
          <el-input v-model="editForm.eventCount" placeholder="几次事件表示完成一次任务"></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input v-model="editForm.sortNo"></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option :value="0" label="启用"></el-option>
            <el-option :value="1" label="禁用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit"
          >提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "Tasks",
  components: { MyPagination },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      groups: [
        { id: 1, name: "Daily tasks" },
        { id: 2, name: "One-time tasks" },
        { id: 3, name: "Common Task" },
      ],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/task-config/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleAdd() {
      this.addForm = {
        name: "",
        description: "",
      };
      this.addFormVisible = true;
    },
    async addSubmit() {
      try {
        await this.axios.form("base:/api/admin/task-config/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("base:/api/admin/task-config/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      try {
        await this.axios.form("base:/api/admin/task-config/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
